<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('leaves')" :icon="'grid'" />
            </div>
            <div 
                class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('store_leaves')"
            >
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <leave-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="leave-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import AppFunction from '../../../../core/helpers/app/AppFunction';
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { formatDateToLocal } from '../../../Helpers/Helpers';
import { status } from '../../../Mixins/FilterMixin';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppLeaves",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'leaves-table',
            rowData: {},
            options: {
                name: 'AppLeaves',
                url: actions.LEAVE,
                showHeader: true,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t(''),
                        type: 'media-object',
                        key: 'employee',
                        mediaTitleKey: '',
                        mediaSubtitleKey: '',
                        default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                        modifier: (value, row) => {
                            return value.photo; // imag url
                        },
                    },
                    {
                        title: this.$t('employee'),
                        type: 'object',
                        key: 'employee',
                        modifier: (employee => {
                            return employee ? `${employee.first_name} ${employee.last_name}` : '-';
                        })
                    },
                    {
                        title: this.$t('leave_type'),
                        type: 'object',
                        key: 'leave_type',
                        modifier: (leaveType => {
                            return leaveType ? `${leaveType.name} (${leaveType.code})` : '-';
                        })
                    },
                    {
                        title: this.$t('start_date'),
                        type: 'object',
                        key: 'start_date',
                        modifier: (date => formatDateToLocal(date))
                    },
                    {
                        title: this.$t('end_date'),
                        type: 'object',
                        key: 'end_date',
                        modifier: (date => formatDateToLocal(date))
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: (status => {
                            switch (status) {
                                case 'pending':
                                    return `<span class="badge badge-pill badge-warning">${this.$t('pending')}</span>`;
                                case 'approved':
                                    return `<span class="badge badge-pill badge-success">${this.$t('approved')}</span>`;
                                case 'rejected':
                                    return `<span class="badge badge-pill badge-danger">${this.$t('rejected')}</span>`;
                                default:
                                    return '-';
                            }
                        })
                    },

                    {
                        title: this.$t('created_by'),
                        type: 'object',
                        key: 'created_by',
                        modifier: (user => {
                            return user ? `${user.first_name} ${user.last_name}` : '-';
                        })
                    },

                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'leave-add-modal',
                        modalId: 'leave-add-edit-modal',
                        modifier: () => this.$can('update_leaves'),

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                        modifier: () => this.$can('delete_leaves'),
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#leave-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.LEAVE}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.LEAVE}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#leave-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
